import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';

import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { ListboxModule } from 'primeng/listbox';

import { ContextEffects, ContextFacade, contextFeature } from './store';
import { DefaultContextDialogComponent } from './components';
import { EffectsModule } from '@ngrx/effects';
import { SelectModule } from 'primeng/select';
import { TranslocoPipe } from '@jsverse/transloco';

const PRIMENG_MODULES = [ButtonModule, SelectModule, DialogModule, ListboxModule, TooltipModule];

@NgModule({
  declarations: [DefaultContextDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...PRIMENG_MODULES,
    StoreModule.forFeature(contextFeature),
    EffectsModule.forFeature(ContextEffects),
    TranslocoPipe,
  ],
  providers: [ContextFacade],
})
export class ContextModule {}
